//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Grid, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { useOtSelector } from '@react/redux/store'
import { ExchangeRateTypeEnum } from '@shared/Enums'
import { EthAddr } from '@shared/SchemaTypes'
import { PoolLytOverviewCTO } from '@shared/PoolLytOverviewCTO'
import { logOT } from '@shared/loggingShared'
import LytSetDynamicExchangeRateForm from './LytSetDynamicExchangeRateForm'

export default function LytSetExchangeRateForm(props: { poolAddr: EthAddr }): ReactElement {
  const { poolAddr } = props
  const poolCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr] as PoolLytOverviewCTO)

  const exchangeRateType = poolCTO.exchangeRateType

  logOT.info('FOCUS: LytPool exchangeRateType', exchangeRateType)
  return (
    <div data-testid="LYT_EXCHANGE_RATE_FORM">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            LytPool Exchange rate form
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: 2 }}>
        {exchangeRateType === ExchangeRateTypeEnum.Dynamic && <LytSetDynamicExchangeRateForm poolAddr={poolAddr} />}
      </Grid>
    </div>
  )
}
